<template>
  <v-row>
    <v-col md="2" cols="12">
      <v-select
        :items="viewItems"
        item-text="name"
        item-value="id"
        v-model="viewType"
        :label="$t('display/offer:create.view')"
        outlined
      />

      <v-autocomplete
        clearable
        outlined
        hide-selected
        multiple
        small-chips
        :menu-props="{bottom: true, offsetY: true}"
        :items="tagItems"
        item-text="name"
        item-value="id"
        v-model="selectedTags"
        :label="$t('display/offer:create.keyword-tag-filter')"
      />

      <v-autocomplete
        clearable
        outlined
        hide-selected
        multiple
        small-chips
        :menu-props="{bottom: true, offsetY: true}"
        :items="buildingOptions"
        item-text="name"
        item-value="id"
        v-model="selectedBuildings"
        :label="$t('display/offer:create.building-types')"
      />

      <RegionsComponent
        ref="regions"
        @regionUpdated="updateRegion"
      />
    </v-col>
    <v-col md="10" cols="12">
      <GridElevators
        v-if="viewType == 'grid'"
        ref="gridElevator"
        :elevators="elevators"
        @hideElevator="(v) => excludedElevators.push(v)"
      />
      <TableElevators
        v-if="viewType == 'table'"
        ref="tableElevator"
        :elevators="elevators"
        @hideElevator="(v) => excludedElevators.push(v)"
      />
    </v-col>
  </v-row>
</template>

<script>
import GridElevators from "./step2/GridElevators";
import RegionsComponent from "@/modules/display/views/offer/create-campaign/step2/RegionsComponent";
import InfoService from "@/modules/core/services/info-service";
import OfferService from "@/modules/display/services/offer-service";
import ElevatorFilter from "@/modules/display/data/elevator-filter";
import TableElevators from "./step2/TableElevators";
import Utils from '@/modules/core/services/utils';

export default {
  name: "SecondStep",
  components: {
    TableElevators,
    GridElevators,
    RegionsComponent
  },
  data() {
    return {
      buildingOptions: [],
      selectedBuildings: null,
      excludedElevators: [],
      elevators: [],
      elevatorFilter: null,
      viewType: "grid",
      selectedTags: [],
      tagItems: []
    }
  },
  created() {
    this.elevatorFilter = new ElevatorFilter();
    InfoService.readOptionsByUrl('display/tag/building-types',
      (response) => {
        this.buildingOptions = [];
        response.forEach(
          (item) => {
            this.buildingOptions.push({
              id: item.id,
              name: `${item.name} (${item.count})`
            })
          }
        );
      },
      () => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/offer:overview.snackbar.building-types')}));
      }
    );
    InfoService.readOptionsByUrl('display/tag/keywords-tags',
      (response) => {
        this.tagItems = [];
        response.forEach(
          (item) => {
            this.tagItems.push({
              id: item.id,
              name: item.name
            })
          }
        );
      },
      () => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:tags')}));
      }
    );
    this.filterElevators();
  },
  methods: {
    filterElevators() {
      OfferService.readElevatorFromAPI(
        this.elevatorFilter,
        (response) => {
          this.elevators = response.data;
          this.showElevators();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:elevator_plural')}));
        }
      )
    },
    showElevators() {
      let elevatorList = [];

      if (this.excludedElevators.length > 0) {
        this.elevators.forEach(
          (elevator) => {
            if (!this.isHide(elevator.elevatorId)) {
              elevatorList.push(elevator);
            }
          }
        );
      } else {
        elevatorList = this.elevators;
      }

      if (this.viewType === 'grid') {
        this.$refs.gridElevator.formatElevator(elevatorList);
      } else {
        this.$refs.tableElevator.formatElevator(elevatorList);
      }
    },
    updateRegion(regions) {
      this.elevatorFilter.regions = regions;
      this.filterElevators();
    },
    clear() {
      this.selectedBuildings = null;
      this.excludedElevators = [];
      this.viewType = 'grid';
      this.selectedTags = [];
      this.$refs.regions.clear();
    },
    clearExcludedElevator() {
      this.excludedElevators = [];
    },
    isHide(elevatorId) {
      for(let i = 0; i < this.excludedElevators.length; i++) {
        if (elevatorId ===  this.excludedElevators[i]) {
          return true;
        }
      }

      return false;
    },
    getModelValues() {
      return {
        "selectedTags": this.selectedTags,
        "selectedTagsWithName": this.getNameByTags(),
        "selectedBuildings": this.selectedBuildings,
        "selectedElevators": this.elevators,
        "excludedElevators": this.excludedElevators,
        "selectedRegions": this.elevatorFilter.regions
      };
    },
    getNameByTags() {
      if(this.selectedTags == null || this.selectedTags.length === 0) {
        return '';
      }

      let selectedTagText = '';
      for (let i = 0; i < this.selectedTags.length; i++) {
        selectedTagText += this.getTagNameById(this.selectedTags[i]) + ', ';
      }

      return selectedTagText.slice(0, -2);
    },
    getTagNameById(tagId) {
      if (tagId === null) {
        return '';
      }

      for(let i = 0; i < this.tagItems.length; i++) {
        if (tagId === this.tagItems[i].id) {
          return this.tagItems[i].name;
        }
      }

      return '';
    },
    // there is no possibility to create the interface, and this method looks as unnecessary.
    // It invokes in CreateCampaign component
    previousStep() {
    },
    couldContinue() {
      return true;
    }
  },
  watch: {
    selectedBuildings() {
      this.elevatorFilter.buildingTypes = [];

      this.selectedBuildings.forEach(
        (item) => {
          this.elevatorFilter.buildingTypes.push(item);
        }
      );

      this.filterElevators();
    },
    selectedTags() {
      this.elevatorFilter.tags = [];

      this.selectedTags.forEach(
        (item) => {
          this.elevatorFilter.tags.push(item);
        }
      );

      this.filterElevators();
    },
    excludedElevators() {
      this.showElevators();
    }
  },
  computed: {
    viewItems() {
      return [
        {
          "id": "table",
          "name": this.$t('display/offer:create.table-view')
        },
        {
          "id": "grid",
          "name": this.$t('display/offer:create.grid')
        }
      ];
    }
  }
}
</script>
